import {Injectable} from "@angular/core";
import {lastValueFrom, Observable} from "rxjs";
import {AddonCategory} from "../../Model/User/AddonCategory";
import {SearchForm} from "../../Model/Dto/SearchForm";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Workflow} from "../../Model/Dto/Workflow/Workflow";

@Injectable()
export class SearchFormsService {

  private readonly apiUrl = 'api/SearchForm';

  constructor(private http: HttpClient) {
  }

  public getAllSearchFormsByCustomerId(customerId: string): Promise<SearchForm[]> {
    const url = `${this.apiUrl}/GetAllSearchFormsByCustomerId`;
    const params = new HttpParams().append('customerId', customerId);
    const options = {params};

    var result = this.http.get<SearchForm[]>(url, options);
    return lastValueFrom(result);
  }

  public async getAll(customerId: string): Promise<SearchForm[]> {
    const url = `${this.apiUrl}/GetAll`;
    const params = new HttpParams().append('customerId', customerId);
    const options = {params};
    var result = this.http.get<SearchForm[]>(url, options);
    return await lastValueFrom(result);
  }

  public async getAllbyUserId(customerId: string, userId: string): Promise<SearchForm[]> {
    const url = `${this.apiUrl}/GetAllbyUserId`;
    const params = new HttpParams().append('customerId', customerId).append('userId', userId);
    const options = {params};
    var result = this.http.get<SearchForm[]>(url, options);
    return await lastValueFrom(result);
  }

  public async delete(deletedSearchForm: SearchForm, customerId: string): Promise<SearchForm[]> {
    const url = `${this.apiUrl}/Delete`;
    const params = new HttpParams().append('customerId', customerId).append('id', deletedSearchForm.id);
    const options = {params};
    
    var result = this.http.delete<SearchForm[]>(url, options);
    return await lastValueFrom(result);
  }


  public updateOrCreateSearchForm(updateSearchForm: SearchForm, customerId: string): Promise<SearchForm> {
    const url = `${this.apiUrl}/Update`;
    const options = {
      headers: new HttpHeaders().append("Content-Type", "application/json"),
      params: new HttpParams().append("customerId", customerId)
    }
    var result = this.http.post<SearchForm>(url, updateSearchForm, options);
    return lastValueFrom(result);
  }

}